<section>
  <div class="content">
    <div class="headline-area">
      <h1>Board</h1>
      <div class="search-input">
        <input #searchInput type="text" placeholder="Find Task" class="searchTitle" name="searchTitle" (keyup)="searchTasks()">
        <button class="search-button" (click)="searchTasks()">
          <div class="hyphen"></div>
          <img src="assets/img/kanban-board/search.png" alt="Search" width="20">
        </button>
        <button class="add-task-button" (click)="boardService.toggleAddOverlayColumn('to do')">Add task +</button>
      </div>
    </div>

    <div class="headline-area-mobile">
      <div class="mobileDiv">
        <h1>Board</h1>
        <button class="add-task-button" (click)="boardService.toggleAddOverlayColumn('to do')">+</button>
      </div>

      <div class="search-input">
        <input #searchInputMobile type="text" placeholder="Find Task" class="searchTitleMobile" name="searchTitle" (keyup)="searchTasksMobile()">
        <button class="search-button" (click)="searchTasksMobile()">
          <div class="hyphen"></div>
          <img src="assets/img/kanban-board/search.png" alt="Search" width="20">
        </button>
      </div>
    </div>


    <div class="board">
      <div class="task-column">
        <div class="add-area">
          <h3>To do</h3> <button class="small-add-task-button" (click)=" boardService.toggleAddOverlayColumn('to do')">+</button>
        </div>
        <div class="task-columns" cdkDropList [cdkDropListData]="tasksSearchAndStatus('to do', searchValue)"
          [cdkDropListConnectedTo]="['in progress', 'await feedback', 'done']" (cdkDropListDropped)="drop($event)"
          id="to do">
          @if (tasksSearchAndStatus('to do', searchValue).length === 0) {
          <div class="no-task-place-holder">No tasks to do</div>
          } @else {
          @for (task of tasksSearchAndStatus('to do', searchValue); track $index) {
          <app-card id="card-desktop" [cdkDragData]="task" [task]="task" (click)="boardService.openFullCard(task)"
            cdkDrag></app-card>
          <app-card class="card-mobile" (mousedown)="startDragMobile($event)" (touchstart)="startDragMobile($event)"
            (mousemove)="onDragMobile($event)" (touchmove)="onDragMobile($event)" (mouseup)="endDragMobile()"
            (mouseleave)="endDragMobile()" (touchend)="endDragMobile()" [task]="task"
            (click)="!isDraggingMobile && boardService.openFullCard(task)"></app-card>
          }
          }
        </div>
      </div>

      <div class="task-column">
        <div class="add-area">
          <h3>In progress</h3> <button class="small-add-task-button" (click)=" boardService.toggleAddOverlayColumn('in progress')">+</button>
        </div>
        <div class="task-columns" cdkDropList [cdkDropListData]="tasksSearchAndStatus('in progress', searchValue)"
          [cdkDropListConnectedTo]="['to do', 'await feedback', 'done']" (cdkDropListDropped)="drop($event)"
          id="in progress">
          @if (tasksSearchAndStatus('in progress', searchValue).length === 0) {
          <div class="no-task-place-holder">No tasks to do</div>
          } @else {
          @for (task of tasksSearchAndStatus('in progress', searchValue); track $index) {
          <app-card id="card-desktop" [cdkDragData]="task" [task]="task" (click)="boardService.openFullCard(task)"
            cdkDrag></app-card>
          <app-card class="card-mobile" (mousedown)="startDragMobile($event)" (touchstart)="startDragMobile($event)"
            (mousemove)="onDragMobile($event)" (touchmove)="onDragMobile($event)" (mouseup)="endDragMobile()"
            (mouseleave)="endDragMobile()" (touchend)="endDragMobile()" [task]="task"
            (click)="!isDraggingMobile && boardService.openFullCard(task)"></app-card>
          }
          }
        </div>
      </div>

      <div class="task-column">
        <div class="add-area">
          <h3>Await feedback</h3> <button class="small-add-task-button" (click)=" boardService.toggleAddOverlayColumn('await feedback')">+</button>
        </div>
        <div class="task-columns" cdkDropList [cdkDropListData]="tasksSearchAndStatus('await feedback', searchValue)"
          [cdkDropListConnectedTo]="['to do', 'in progress', 'done']" (cdkDropListDropped)="drop($event)"
          id="await feedback">
          @if (tasksSearchAndStatus('await feedback', searchValue).length === 0) {
          <div class="no-task-place-holder">No tasks to do</div>
          } @else {
          @for (task of tasksSearchAndStatus('await feedback', searchValue); track $index) {
          <app-card id="card-desktop" [cdkDragData]="task" [task]="task" (click)="boardService.openFullCard(task)"
            cdkDrag></app-card>
          <app-card class="card-mobile" (mousedown)="startDragMobile($event)" (touchstart)="startDragMobile($event)"
            (mousemove)="onDragMobile($event)" (touchmove)="onDragMobile($event)" (mouseup)="endDragMobile()"
            (mouseleave)="endDragMobile()" (touchend)="endDragMobile()" [task]="task"
            (click)="!isDraggingMobile && boardService.openFullCard(task)"></app-card>
          }
          }
        </div>
      </div>

      <div class="task-column">
        <div class="add-area">
          <h3>Done</h3>
        </div>
        <div class="task-columns" cdkDropList [cdkDropListData]="tasksSearchAndStatus('done', searchValue)"
          [cdkDropListConnectedTo]="['to do', 'in progress', 'await feedback']" (cdkDropListDropped)="drop($event)"
          id="done">
          @if (tasksSearchAndStatus('done', searchValue).length === 0) {
          <div class="no-task-place-holder">No tasks to do</div>
          } @else {
          @for (task of tasksSearchAndStatus('done', searchValue); track $index) {
            <app-card id="card-desktop" [cdkDragData]="task" [task]="task" (click)="boardService.openFullCard(task)"
              cdkDrag></app-card>
            <app-card class="card-mobile" (mousedown)="startDragMobile($event)" (touchstart)="startDragMobile($event)"
              (mousemove)="onDragMobile($event)" (touchmove)="onDragMobile($event)" (mouseup)="endDragMobile()"
              (mouseleave)="endDragMobile()" (touchend)="endDragMobile()" [task]="task"
              (click)="!isDraggingMobile && boardService.openFullCard(task)"></app-card>
            }
          }
        </div>
      </div>
    </div>
  </div>

  @if (boardService.fullCardActive && boardService.selectedTask) {
    <app-full-card [task]="boardService.selectedTask"></app-full-card>
  }

  @if (boardService.addCardActive) {
    <app-kanban-add-overlay></app-kanban-add-overlay>
  }


</section>